/* eslint-disable */
export default {
  _Sanchez: 'Sanchez',
  _Quicksand: 'Quicksand',
  _Espresso_Dolce: 'Espresso Dolce',
  _Vice_City_Sans: 'Vice City Sans',
  _SchulVokalDotless: 'SchulVokalDotless',
}